import { Box, Tbody, Tr, Td } from '@chakra-ui/react';
import { Colors, Icon, Text } from '@mercator-gcp/grout';
import { Link as ReactLink } from 'react-router-dom';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import Table from 'components/layout/Table';
import { InvolvedResponse } from 'hooks/useCompanies';
import { CompanyData } from 'pages/ProjectDetails/CompanyData';
import { formatCompanyName, formatCompanyAlias } from 'utils/format';

/** API returns these counts; ProjectCompany type may not include them yet */
const getNumActiveProjects = (company: {
  num_active_projects?: number;
  num_active_documents?: number;
}) => (company.num_active_projects ?? 0) + (company.num_active_documents ?? 0);

const nameWithIdStyle = {
  color: Colors.ForestGreen900,
  _hover: {
    textDecoration: 'underline',
  },
};

const noCompaniesTextStyle = {
  color: '#76746F',
  fontSize: '13px',
  textAlign: 'center',
};

type InvolvementsProps = {
  involved: InvolvedResponse | null;
};

const InvolvedCompanies = ({ involved }: InvolvementsProps) => {
  if (involved?.length === 0) {
    return (
      <Table>
        <Tbody>
          <Tr>
            <Td>
              <FlexRow>
                <Text sx={noCompaniesTextStyle}>
                  No companies found associated with this project.
                </Text>
              </FlexRow>
            </Td>
          </Tr>
        </Tbody>
      </Table>
    );
  }

  return (
    <Table
      header={
        <FlexRow>
          <FlexRow.Left>
            <Text.SmallLabel color={Colors.ArmyGreen500}>
              Companies Involved
            </Text.SmallLabel>
          </FlexRow.Left>
          <FlexRow.Right>
            <Text.Small>{involved?.length}</Text.Small>
          </FlexRow.Right>
        </FlexRow>
      }
    >
      <Tbody>
        {involved?.map((company, index) => {
          return (
            <Tr key={`${company.toString() + index}`} className="no-break-on-print">
              <Td>
                <FlexColumn>
                  {company.uuid ? (
                    <FlexRow>
                      <ReactLink to={`/companies/${company.uuid}`}>
                        <FlexRow justifyContent="flex-start">
                          <Text.BodyBold sx={nameWithIdStyle}>
                            {!!company.name && formatCompanyName(company.name)}
                          </Text.BodyBold>
                          <Icon
                            name={Icon.Name.ChevronRight}
                            fill={Colors.ForestGreen900}
                            size={14}
                          />
                        </FlexRow>
                        <FlexRow>
                          <CompanyData
                            uuid={company.uuid}
                            company_types={company.company_types || []}
                            numActiveProjects={getNumActiveProjects(
                              company as {
                                num_active_projects?: number;
                                num_active_documents?: number;
                              },
                            )}
                          />
                        </FlexRow>
                      </ReactLink>
                    </FlexRow>
                  ) : (
                    company.name &&
                    company.name.split(';').map((name) => (
                      <Box key={name}>
                        <FlexRow>
                          <Text.BodyBold>{formatCompanyAlias(name)}</Text.BodyBold>
                        </FlexRow>
                      </Box>
                    ))
                  )}
                </FlexColumn>
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
};

export default InvolvedCompanies;
